<template lang="pug">
main
  .col-md-12.hexagon-container
    item(v-for="(o, index) in lstItems", :title="o.name", :key="o.id", :id="o.id", :index="index" :isSelected="o.selected", @onListSelect="onSubjectSelected")
</template>

<script>
import Item from './item'
// import gql from 'graphql-tag'
// import graphql from '../Model/graphql'

export default {
  components: {
    Item
  },
  props: {
    lstItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      // subjects: []
    }
  },
  methods: {
    onSubjectSelected(index) {
      // console.log('Item selected beehive ' + this.lstItems[index].name)
      var selItem = this.lstItems[index]
      selItem.selected = !selItem.selected
      this.$set(this.lstItems, index, selItem)
      this.$emit('onlstItems', this.lstItems)
    }
  }
  // apollo: {
  //   'subjects': {
  //     query: gql(graphql.GET_SUBJECTS),
  //     update: data => {
  //       // console.log(data)
  //       for (var i = 0; i < data.subjects.length; i++) {
  //         data.subjects[i].selected = false
  //       }
  //       return data.subjects
  //     }
  //   }
  // }
}
</script>



// WEBPACK FOOTER //
// BeeHive.vue?53a44382